export const getLomaCookieDomain = (): string | null => {
  if (typeof window === 'undefined') return null;
  const hostname = window.location.hostname;
  // For localhost, return null to avoid setting domain attribute (browsers reject .localhost)
  return hostname.endsWith('.staging.withloma.com') || hostname === 'staging.withloma.com'
    ? '.staging.withloma.com'
    : hostname.endsWith('.withloma.com') || hostname === 'withloma.com'
    ? '.withloma.com'
    : null;
};

export const setCookie = (
  name: string,
  value: string,
  options: any,
  skipDomain?: boolean,
): void => {
  const cookieOptions = {
    path: '/',
    SameSite: 'Lax', // Allow cookie in top-level navigation (OAuth redirects) and same-site requests
    ...options,
  };

  // Add Secure flag in non-development environments
  if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
    cookieOptions['Secure'] = true;
  }

  if (!skipDomain) {
    const domain = getLomaCookieDomain();
    if (domain) {
      cookieOptions['domain'] = domain;
    }
  }

  let updatedCookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)};`;
  for (const optionKey in cookieOptions) {
    updatedCookie += ` ${optionKey}`;
    const optionValue = cookieOptions[optionKey];
    if (optionValue !== true) {
      updatedCookie += `=${optionValue};`;
    } else {
      updatedCookie += ';';
    }
  }
  document.cookie = updatedCookie;
};

export const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() ?? null;
  }
  return null;
};

export const deleteCookie = (name: string): void => {
  setCookie(name, '', {
    expires: 'Thu, 01 Jan 1970 00:00:00 UTC',
  });
  // specifically delete hostname cookies on logout, as they may be lingering
  // this prevents site.withloma.com cookies lingering after removing .withloma.com cookies
  const domain = getLomaCookieDomain();
  if (domain) {
    setCookie(
      name,
      '',
      {
        expires: 'Thu, 01 Jan 1970 00:00:00 UTC',
      },
      true,
    );
  }
};

export const getExpires = (expires: number): string => {
  return new Date(expires * 1000).toUTCString();
};
